import { render, staticRenderFns } from "./CallsLogs.vue?vue&type=template&id=79553ba4"
import script from "./CallsLogs.vue?vue&type=script&lang=js"
export * from "./CallsLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports